import { useEffect, useSyncExternalStore, type DependencyList } from "react";

import { useAsyncTaskContext } from "../context/AsyncTaskContext";
import type { RegisterConfig } from "../types";

export interface UseAsyncTasksOptions {
  /** Mount-time subscription — cleaned up on unmount. */
  register?: RegisterConfig;
  registerDeps?: DependencyList;
}

export function useAsyncTasks(options?: UseAsyncTasksOptions) {
  const ctx = useAsyncTaskContext();
  const registerConfig = options?.register;
  const registerDeps = options?.registerDeps;

  const tasks = useSyncExternalStore(
    ctx.subscribe,
    ctx.getTasks,
    ctx.getTasks,
  );

  useEffect(() => {
    if (!registerConfig) return undefined;
    return ctx.register(registerConfig);
  }, registerDeps ?? [registerConfig, ctx]);

  return {
    ...ctx,
    tasks,
  };
}
